/**
 * Shared player UI constants
 */

/**
 * Gradient classes for player overlay chrome
 * Top gradient: fades from dark at top to transparent
 * Bottom gradient: fades from dark at bottom to transparent
 */
export const OVERLAY_GRADIENT_TOP = "bg-gradient-to-b from-black/80 via-black/30 to-transparent";
export const OVERLAY_GRADIENT_BOTTOM = "bg-gradient-to-t from-black/80 via-black/30 to-transparent";
